import { TracingPlanTaskObservation } from './tracing-plan-task-observation';
import { ThirdPartyEvaluationFormItemFile } from './thirdparty-evaluation-form-item-file';
import { ThirdPartyFollowUpTaskExternalDto } from './thirdparty-tracing-tasks/thirdparty-tracing-task-external';
import { FollowUpResponseEnum } from './tracing-plan-task-item';

export class TracingPlanTaskDetail {
    tracingPlanId: number = 0;
    tracingTaskId: number = 0;
    tracingSubTaskId?: number = null;
    tracingPlanTaskParentId: number = 0;
    taskDescription: string = '';
    assignedRoleId: number = 0;
    assignedRole: string = '';
    expirationDate: Date = null;
    progressPercent: number = 0; // en formato [0; 1]
    lastActionDate: Date = null;
    thirdPartyFollowUpTaskExternalDto: ThirdPartyFollowUpTaskExternalDto;
    tracingTaskObservation: TracingPlanTaskObservation[] = [];
    followUpResponseEnum: FollowUpResponseEnum;

    files: {
        fileId: number,
        tracingTaskItemId: Number
    } [] = [];
    fileWithItems: {
        thirdPartyEvaluationFormItemId: number,
        createUser: string,
        file: ThirdPartyEvaluationFormItemFile
    }[] = [];

    constructor() {
    }
}
